import { render, staticRenderFns } from "./toolmanager-side.html?vue&type=template&id=d2245136&scoped=true&"
import script from "./toolmanager-side.js?vue&type=script&lang=js&"
export * from "./toolmanager-side.js?vue&type=script&lang=js&"
import style0 from "./toolmanager-side.scss?vue&type=style&index=0&id=d2245136&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2245136",
  null
  
)

export default component.exports